import React from "react";
import { AppRouteURI, AppRoutingRoles } from "router/RoleBasedAccess";
import App from "../app/App";
import UsersContainer from "./UsersContainer";

export default () => {
  const { isProtected, checkRoles } = {
    ...AppRoutingRoles[AppRouteURI.MEMBERS],
  };
  return (
    <App isProtected={isProtected} checkRoles={checkRoles}>
      <UsersContainer />
    </App>
  );
};
